<template>
  <div class="solution">
    <banner/>
    <router-view></router-view>
  </div>
</template>
<script>
import banner from '@/mobile/components/banner'
export default {
  name: 'Solution',
  components: {
    banner
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // vm.$router.replace({ name: 'Home', params: { source: 'solution' } })
    })
  }
}
</script>
<style>
@import url('../../styles/reset.css');
</style>
<style lang="scss" scoped>

</style>
